import {
  CrudFormConfig,
  CrudViewFormItemType,
  FormLayout
} from '@rappider/rappider-components/utils';

/**
 * Project information form configuration
 *
 * Defines the form fields and layout for displaying project information
 * including project details, framework info, and database settings.
 */
export const projectInformationFormConfig: CrudFormConfig = {
  items: [
    {
      section: 'Project Information',
      fieldName: 'id',
      title: 'Project Id',
      type: CrudViewFormItemType.Label
    },
    {
      section: 'Project Information',
      fieldName: 'createdBy',
      title: 'Created By',
      type: CrudViewFormItemType.Label
    },
    {
      section: 'Project Information',
      fieldName: 'createdDate',
      title: 'Created Date',
      type: CrudViewFormItemType.Label,
      displayFormatFunction: (value: string) => value ? new Date(value).toLocaleDateString() : ''
    },
    {
      section: 'Project Information',
      fieldName: 'hasAuthenticationModule',
      title: 'Authentication?',
      type: CrudViewFormItemType.CheckBox
    },
    {
      section: 'Project Information',
      fieldName: 'appType',
      title: 'Application Type',
      type: CrudViewFormItemType.Label
    },
    {
      section: 'Project Information',
      fieldName: 'frontendFramework',
      title: 'FrontEnd Programming Language & Framework',
      type: CrudViewFormItemType.Label,
      displayFormatFunction: (value: string) => value === 'angular' ? 'Typescript & Angular' : value
    },
    {
      section: 'Project Information',
      fieldName: 'backendFramework',
      title: 'Backend Programming Language & Framework',
      type: CrudViewFormItemType.Label,
      displayFormatFunction: (value: string) => value === 'loopback4' ? 'NodeJS & Loopback' : value
    },
    {
      section: 'Project Information',
      fieldName: 'database',
      title: 'Database',
      type: CrudViewFormItemType.Label,
      displayFormatFunction: () => 'MongoDB'
    }
  ],
  formLayout: FormLayout.Vertical
};
